import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilsService } from '../../services/utils.service';
import { CategoryService } from '../../services/category.service';
import { InputformsComponent } from "../inputforms/inputforms.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-book-consultation',
  standalone: true,
  imports: [InputformsComponent,CommonModule],
  templateUrl: './book-consultation.component.html',
  styleUrl: './book-consultation.component.scss'
})
export class BookConsultationComponent {
  environment: any = environment;
  formName = 'bookConsultation';
  showForm: boolean = false;
  sub:Subscription=new Subscription()
  constructor(public utils: UtilsService, public catService: CategoryService, public dialogRef: MatDialogRef<BookConsultationComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    this.showForm = true;
  }

  submitForm(formData: any) {
    this.utils.showLoading();
    let body = {
      "name": formData.value.name,
      "emailId": formData.value.email,
      "mobileNumber": formData.value.phone ? Number(formData.value.phone) : '',
      "location": formData.value.location
    }
    this.sub.add(this.catService.bookConsultation(body).subscribe((data: any) => {
      if (data && data['success']) {
        this.utils.hideLoading();
        this.utils.openSnackBar('Thank you, someone from solar team will contact you.', 'success-toster');
        this.onNoClick();
      }
      else {
        this.utils.hideLoading();
        this.utils.openSnackBar(data.message, 'error-toster');
      }
    }))
  }

  onNoClick(): void {
    this.dialogRef.close()
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
